import axiosInstance from '../../../../config/axiosInstance';
import { ProjectMemberValidation } from "../../views/ProjectMember/Validation/ProjectMemberValidation";
const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = ProjectMemberValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateProjectMember`, formData);
      setFormData({
        ID: '',
        ProjectID:'',
        UserID:'',
        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };